// extracted by mini-css-extract-plugin
export default {"title":"Formation_title__fQ2E-","section":"Formation_section__RDe5e","container":"Formation_container__0UySd"};